import {useState} from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";

function Buscador() {
    const [query, setQuery] = useState('');
    const [search, setSearch] = useState(false);
    const navigate = useNavigate();
    let container = {
        position: 'fixed',
        top: '85px',
        zIndex: '1050',
        right: '15px',
        width: search ? '500px' : '58px',
        maxWidth: '75%',
        backgroundColor: 'var(--light-orange)',
        padding: '0px 6px 0px 0px',
        borderRadius: '40px',
        height: '58px',
        border: 'solid 0px #ccc'
    };
    let glassStyle = {}
    let searchBarStyle = {
        marginRight: '0px',
        marginLeft: '0px'
    }
    if (isMobile) {
        glassStyle = {
            marginTop: '14px',
            marginLeft: '8px'
        }
        searchBarStyle = {
            marginRight: '-4px !important'
        }
    }
    return (
        <div className="search-bar order-xl-2 order-lg-1 order-1"
            style={{...container, ...searchBarStyle}}>
            <div className="container px-0">
                <div className="row buscador px-0" style={searchBarStyle}>
                    <div className="search-bar" style={{padding: 0, ...searchBarStyle }}>
                        <input
                            type="text"
                            className="form-control me-lg-2 me-0 py-3"
                            style={{
                                width: '100%',
                                display: search ? 'block' : 'none',
                                height: '58px',
                                border: 'solid 1px var(--light-orange)'
                            }}
                            id="query"
                            name="query"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            placeholder="Buscar"
                            aria-label="Buscar"
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    navigate(`/catalogo/buscar/${query}`, { replace: false });
                                    navigate(0);
                                }
                            }}
                        />
                        <i className="fa-solid fa-xmark" 
                            style={{ 
                                display: !isMobile ? 'none' : search ? 'block' : 'none',
                                cursor: 'pointer', 
                                color: '#000', 
                                fontSize: '21px', 
                                position: 'absolute', 
                                right: '55px', 
                                top: '17px',
                                zIndex: '1000'
                            }}
                            onClick={() => setSearch(!search)}></i>
                        <i className="fa-solid fa-magnifying-glass" 
                            style={{ 
                                display: !isMobile ? 'none' : search ? 'block' : 'none',
                                cursor: 'pointer', 
                                color: '#000', 
                                fontSize: '21px', 
                                position: 'absolute', 
                                right: '15px', 
                                top: '17px',
                                zIndex: '1000'
                            }}
                            onClick={() => {
                                setSearch(!search);
                                navigate(`/catalogo/buscar/${query}`, { replace: false });
                                navigate(0);
                            }}></i>
                        <button
                            className={'btn btn-buscador-icono'}
                            onClick={() => {
                                setSearch(!search);
                                //navigate(`/catalogo/buscar/${query}`, { replace: false });
                                //navigate(0);
                            }}
                            style={{ cursor: 'pointer', border: 0 }}
                        >
                            <i className="fa-solid fa-magnifying-glass"
                               style={{ cursor: 'pointer', color: '#fff', fontSize: '21px', ...glassStyle }}
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Buscador;